import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { LeadershipTeamMembersLeadershipTeamMember, LeadershipTeamUnAssignCommand } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RemoveModalTypes {
	memberDetail?: LeadershipTeamMembersLeadershipTeamMember;
	getLeadershipTeamData: () => Promise<void>;
	closeModal?: closeModalType;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({ memberDetail, getLeadershipTeamData, closeModal }) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmRemove = async () => {
		if (memberDetail && memberDetail.userId) {
			setIsLoading(true);

			const data: LeadershipTeamUnAssignCommand = { userId: memberDetail.userId };

			const response = await apibridge.removeLeadershipTeamMember(data);

			if (response.isError) {
				setIsLoading(false);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else {
				setIsLoading(false);

				if (closeModal) {
					closeModal();
				}

				getLeadershipTeamData();
			}
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove{' '}
									<strong>
										'{memberDetail?.firstName} {memberDetail?.lastName}'?
									</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmRemove}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
